import { extendTheme } from '@chakra-ui/react';

import { ButtonVariants } from '../../components/button/button-variants';
import { styles } from '../global-styles';
import { config } from './config';
import { breakpoints } from './foundations/breakpoints';
import { colors } from './foundations/colors';

const baseTheme = {
    config,
    breakpoints,
    colors,
    components: { Button: { ...ButtonVariants } },
    styles
};

/**
 * Extend the base shared theme with the custom colors and variants in portal.
 *
 * @see https://chakra-ui.com/docs/theming/customize-theme
 */
export const mathleticsTheme = extendTheme(baseTheme);

export const internalUsersTheme = extendTheme({
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        primary: {
            50: '#b2beb5',
            100: '#d3d3d3',
            200: '#a9a9a9',
            500: '#36454f',
            600: '#415667',
            700: '#808080',
            800: '#818589',
            900: '#e5e4e2'
        }
    }
});
